import S, { DataSignal } from 's-js';
import { DomainSummary } from 'data/models/DomainSummary';
import { UserSummary } from 'data/models/UserSummary';
import { IAjax } from 'lib/Ajax';
import { Entrypoints } from 'core/app/entrypoints';

export type Navbar = ReturnType<typeof Navbar>;
export function Navbar(
    domain : DomainSummary,
    user : DataSignal<UserSummary | null>,
    ajax : IAjax,
    entrypoints : Entrypoints
) {
    const userAbbreviation = () => {
        let u = user();
        if (!u) return null;
        let firstName = u.FirstName(),
            lastName = u.LastName() || '',
            firstInitial = firstName ? firstName[0] + '. ' : '';
        return firstInitial + lastName;
    };

    const showActionsMenu = S.data(false);

    return {
        User: () => user(),
        Logout: Logout,
        UserAbbreviation: userAbbreviation,
        Domain: domain,
        ShowActionsMenu: showActionsMenu,
        ToggleActionsMenu
    };

    function ToggleActionsMenu() {
        showActionsMenu(!showActionsMenu());
    }

    function MenuAction(action : () => void) {
        return () => S.freeze(() => {
            action();
            showActionsMenu(false);
        });
    }

    function Logout() {
        ajax.Url(entrypoints.Logout).Post({}).then(function () {
            user(null);
            window.location.hash = '#';
        });
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/navbar/model.ts